const config = window.AbdelmegedTheme || {};
const directionKey = config.storageKeys?.direction || 'abdelmeged_direction';
const validDirections = new Set(['rtl', 'ltr']);

const storedDirection = () => {
  try {
    return localStorage.getItem(directionKey);
  } catch {
    return null;
  }
};

const applyDirection = (direction) => {
  if (!validDirections.has(direction)) {
    return;
  }

  document.documentElement.dir = direction;
  document.documentElement.dataset.direction = direction;
};

const initialDirection = () => {
  if (config.features?.languageSwitching === false) {
    return config.direction || document.documentElement.dir;
  }

  return storedDirection() || config.direction || document.documentElement.dir;
};

applyDirection(initialDirection());

window.addEventListener('abdelmeged:languagechange', (event) => {
  applyDirection(event.detail?.direction);
});
